import React, { useId } from 'react';
import { siUbereats, siGlovo, siDeliveroo } from 'simple-icons';

// Logos de marque officiels (SVG inline) — rendent la vraie identité visuelle
// plutôt qu'un simple texte « Instagram / Facebook / Gmail ».

export const InstagramLogo = ({ size = 18, className = '' }) => {
  const gid = `ig-g-${useId().replace(/:/g, '')}`;
  return (
  <svg width={size} height={size} viewBox="0 0 24 24" className={`brand-logo ${className}`} aria-label="Instagram" role="img">
    <defs>
      <radialGradient id={gid} cx="30%" cy="107%" r="150%">
        <stop offset="0%" stopColor="#fdf497" />
        <stop offset="5%" stopColor="#fdf497" />
        <stop offset="45%" stopColor="#fd5949" />
        <stop offset="60%" stopColor="#d6249f" />
        <stop offset="90%" stopColor="#285AEB" />
      </radialGradient>
    </defs>
    <rect x="1.5" y="1.5" width="21" height="21" rx="6" fill={`url(#${gid})`} />
    <circle cx="12" cy="12" r="4.4" fill="none" stroke="#fff" strokeWidth="1.8" />
    <circle cx="17.3" cy="6.7" r="1.3" fill="#fff" />
  </svg>
  );
};

export const GoogleLogo = ({ size = 18, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" className={`brand-logo ${className}`} aria-label="Google" role="img">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
  </svg>
);

export const FacebookLogo = ({ size = 18, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={`brand-logo ${className}`} aria-label="Facebook" role="img">
    <rect x="1.5" y="1.5" width="21" height="21" rx="6" fill="#1877F2" />
    <path fill="#fff" d="M15.3 12.3l.4-2.6h-2.5V8c0-.73.36-1.44 1.5-1.44h1.14V4.35s-1.03-.18-2.02-.18c-2.06 0-3.4 1.25-3.4 3.5v1.98H8.1v2.6h2.3V19h2.8v-6.7h2.1z" />
  </svg>
);

export const GmailLogo = ({ size = 18, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={`brand-logo ${className}`} aria-label="Gmail" role="img">
    <rect x="2" y="4.5" width="20" height="15" rx="2.5" fill="#fff" stroke="#e0e0e0" strokeWidth="0.5" />
    <path fill="#4285F4" d="M4 19.5H6.5V11L4 9.2z" />
    <path fill="#34A853" d="M20 19.5H17.5V11L20 9.2z" />
    <path fill="#FBBC04" d="M4 6.5v2.7l2.5 1.8V8.3z" />
    <path fill="#EA4335" d="M6.5 8.3l5.5 4.1 5.5-4.1V6.5L12 10.6 6.5 6.5z" />
    <path fill="#C5221F" d="M17.5 8.3V11l2.5-1.8V6.5z" />
  </svg>
);

export const WhatsAppLogo = ({ size = 18, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={`brand-logo ${className}`} aria-label="WhatsApp" role="img">
    <circle cx="12" cy="12" r="10.5" fill="#25D366" />
    <path fill="#fff" d="M12 5.2a6.8 6.8 0 0 0-5.85 10.27L5.2 18.8l3.45-.9A6.8 6.8 0 1 0 12 5.2zm0 12.4a5.6 5.6 0 0 1-2.86-.78l-.2-.12-2.05.54.55-2-.13-.2A5.6 5.6 0 1 1 12 17.6zm3.07-4.2c-.17-.08-1-.49-1.15-.55-.15-.06-.27-.08-.38.08-.11.17-.44.55-.54.67-.1.11-.2.13-.37.04-.17-.08-.71-.26-1.35-.84-.5-.45-.84-1-.94-1.17-.1-.17-.01-.26.07-.34.08-.08.17-.2.25-.3.08-.1.11-.17.17-.28.06-.11.03-.21-.01-.3-.04-.08-.38-.92-.52-1.26-.14-.33-.28-.28-.38-.29h-.33c-.11 0-.3.04-.45.21-.15.17-.59.58-.59 1.41s.6 1.63.69 1.75c.08.11 1.19 1.82 2.88 2.55.4.17.72.28.96.36.4.13.77.11 1.06.07.32-.05 1-.41 1.14-.8.14-.4.14-.73.1-.8-.04-.07-.15-.11-.32-.2z" />
  </svg>
);

export const MetaLogo = ({ size = 18, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={`brand-logo ${className}`} aria-label="Meta" role="img">
    <path fill="#0081FB" d="M2.5 14.6c0-3.9 2-8.1 4.6-8.1 1.5 0 2.7 1 4.9 4.2 2.2-3.2 3.4-4.2 4.9-4.2 2.6 0 4.6 4.2 4.6 8.1 0 2.1-.9 3.3-2.4 3.3-1.6 0-2.5-1.3-4.2-4.3L13 10.2c-.3-.5-.7-1.1-1-1.7-.3.6-.7 1.2-1 1.7l-1.9 3.4c-1.7 3-2.6 4.3-4.2 4.3-1.5 0-2.4-1.2-2.4-3.3zm4.4-5.9c-1.1 0-2.4 2.7-2.4 5.7 0 .9.3 1.5.9 1.5.7 0 1.3-.9 2.5-3L9.8 9.6c-.9-1.4-1.7-.9-2.9-.9zm10.2 0c-1.2 0-2 .5-2.9.9l1.9 3.3c1.2 2.1 1.8 3 2.5 3 .6 0 .9-.6.9-1.5 0-3-1.3-5.7-2.4-5.7z" />
  </svg>
);

// LOT 63 · V5 · logos officiels des plateformes de livraison (simple-icons), en carré arrondi
const carreMarque = (icone, label, fond, trait = '#fff') => ({ size = 30, className = '' }) => (
  <svg width={size} height={size} viewBox="0 0 30 30" className={`brand-logo ${className}`} aria-label={label} role="img">
    <rect width="30" height="30" rx="8" fill={fond} />
    <g transform="translate(6 6) scale(.75)"><path d={icone.path} fill={trait} /></g>
  </svg>
);
export const UberEatsLogo = carreMarque(siUbereats, 'Uber Eats', '#06C167');
export const GlovoLogo = carreMarque(siGlovo, 'Glovo', '#FFC244', '#00A082');
export const DeliverooLogo = carreMarque(siDeliveroo, 'Deliveroo', '#00CCBC');

export const BRAND_LOGOS = { google: GoogleLogo, instagram: InstagramLogo, facebook: FacebookLogo, gmail: GmailLogo, whatsapp: WhatsAppLogo, meta: MetaLogo };

const RX_MARQUES = /\b(WhatsApp|Gmail|Instagram|Facebook|Meta)\b/;
const RX_SPLIT = /\b(WhatsApp|Gmail|Instagram|Facebook|Meta)\b/g;

// Règle globale : chaque mention « WhatsApp · Gmail · Instagram · Meta · Facebook » porte son logo officiel en couleur.
export const Marque = ({ nom, size = 16, children }) => {
  const Logo = BRAND_LOGOS[String(nom).toLowerCase()];
  if (!Logo) return children ?? nom;
  return <span className="marque" data-keepicon=""><Logo size={size} />{children ?? nom}</span>;
};

export const avecLogos = (txt, size = 16) => {
  if (typeof txt !== 'string' || !RX_MARQUES.test(txt)) return txt;
  return txt.split(RX_SPLIT).map((p, i) => (BRAND_LOGOS[p.toLowerCase()] ? <Marque key={i} nom={p} size={size} /> : p));
};
